import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: 'https://server-godday-backend.onrender.com/',
  timeout: 30000, // 30 seconds timeout for large downloads
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only logout on 401 if it's an auth-related endpoint
    // Don't logout for folder password protection or file access issues
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthEndpoint = url.includes('/api/auth/');
      const isProtectedFolderError = error.response?.data?.protected === true;

      // Only logout if it's an auth endpoint failure, not a folder password issue
      if (isAuthEndpoint && !isProtectedFolderError) {
        console.log('🔐 API: Auth token invalid, redirecting to login');
        localStorage.removeItem('token');
        window.location.href = '/';
      } else {
        console.log('🔒 API: Folder access denied, but keeping user logged in');
        // Don't redirect for folder password issues
      }
    }
    return Promise.reject(error);
  }
);

export default api;
